
import { computed, defineComponent, ref, Ref } from 'vue';
import { Form } from 'vee-validate';
import wishListsStore from '@/b2c/wishlists/wish-lists.store';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import utilities from '@/shared/utilities.service';

export default defineComponent({
    name: 'WishListsAddList',
    components: { Form },
    setup() {
        const labels = useBlockLabels();
        const pending: Ref<boolean> = ref(false);
        const timing: number = 2000;

        const submit = async({ name }, { resetForm }): Promise<void> => {
            if (!pending.value) {
                pending.value = true;
                const animationTiming = utilities.delay(timing);
                const promise = await Promise.all([
                    await wishListsStore.createList(name),
                    animationTiming,
                ]);
                pending.value = false;
                resetForm();
                return promise[0];
            }
        };

        const enterAnimation = computed(() => {
            const animation = pending.value ? 'fadeInDown' : 'fadeInUp';
            return `${animation} animated u-anim-dur-300`;
        });

        const leaveAnimation = computed(() => {
            const animation = pending.value ? 'fadeOutDown' : 'fadeOutUp';
            return `${animation} animated u-anim-dur-300`;
        });

        const validation = {
            name: 'required',
        };

        return {
            labels,
            pending,
            validation,
            enterAnimation,
            leaveAnimation,
            submit,
        };
    },
});
